import React from "react";
import { MessageSquare } from "lucide-react";
import { AiOutlineDelete } from "react-icons/ai";

interface ChatHeaderProps {
  onClear: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({ onClear }) => (
  <div className="flex items-center justify-between rounded-t-lg border-b border-b-[#e1e1e1] px-4 py-2">
    <div className="flex items-center space-x-2">
      <MessageSquare className="h-5 w-5 text-[#000000]" />
      <h1 className="text-[32px] font-medium text-[#000000] lg:text-[40px]">
        Chat
      </h1>
    </div>
    <button
      type="button"
      onClick={onClear}
      className="flex items-center gap-1 text-gray-500 transition-colors hover:text-[#000000]"
    >
      <AiOutlineDelete className="h-4 w-4" />
      <span className="text-sm">Clear History</span>
    </button>
  </div>
);
